import { render } from "./Villa.vue?vue&type=template&id=3ca35e5b"
import script from "./Villa.vue?vue&type=script&lang=js"
export * from "./Villa.vue?vue&type=script&lang=js"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__